import React, { useEffect, useState } from 'react';
import Header from '../../Component/common/Header/Header';
import SearchBar from '../../Component/common/SearchBar/SearchBar';
import SelectedPopup from '../../Component/common/selectedPopup';
import RegisteredTable from '../../Component/registeredSellers/RegisteredTable';
import AddSellerForm from '../../Component/registeredSellers/AddRegSellerForm.js';
import Button from '../../Component/common/Button/Button';
import { FiUsers } from 'react-icons/fi';
import '../../style/PageTable.css';
import { API_BASE } from '../../config';

const RegisteredSellersPage = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSeller, setSelectedSeller] = useState(null);

  // useEffect(() => {
  //   const fetchSellers = async () => {
  //     try {
  //       const response = await fetch('/api/vcseller'); // Adjust API endpoint as needed
  //       if (!response.ok) {
  //         throw new Error('Failed to fetch sellers');
  //       }
  //       const data = await response.json();
  //       setSellers(data);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const [showAddForm, setShowAddForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  
  // Form states
  const [newSellerFormData, setNewSellerFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    phoneNumber: '',
    emailID: '',
    passwrd: '',
    website: '',
    city: '',
    state: '',
    pan: '',
    gst: '',
    startDate: '',
    endDate: '',
    years: 1,
    package: '',
    packageId: ''
  });

  const [editingSeller, setEditingSeller] = useState(null);
  const [editFormData, setEditFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    phoneNumber: '',
    emailID: '',
    website: '',
    city: '',
    state: '',
    pan: '',
    gst: '',
    startDate: '',
    endDate: '',
    years: 1,
    package: '',
    packageId: ''
  });

  const fetchSellers = async () => {
    try {
      const response = await fetch('/api/vcseller');
      if (!response.ok) {
        throw new Error('Failed to fetch sellers');
      }
      const data = await response.json();
      setSellers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSellers();
  }, []);

  const filteredSellers = sellers.filter(seller =>
    seller.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    seller.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    seller.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    seller.emailID.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (seller.phoneNumber && seller.phoneNumber.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleRowClick = (sellerId) => {
    const seller = sellers.find(s => s.id === sellerId);
    setSelectedSeller(seller);
  };

  const closePopup = () => {
    setSelectedSeller(null);
  };

  const handleToggleAddForm = () => {
    setShowAddForm(!showAddForm);
    if (!showAddForm) {
      setEditingSeller(null);
      setNewSellerFormData({
        firstName: '',
        lastName: '',
        companyName: '',
        phoneNumber: '',
        emailID: '',
        passwrd: '',
        website: '',
        city: '',
        state: '',
        pan: '',
        gst: '',
        startDate: '',
        endDate: '',
        years: 1,
        package: '',
        packageDetail: ''
      });
    }
  };

  const handleNewSellerChange = (e) => {
    const { name, value } = e.target;
    console.log('Parent handleNewSellerChange:', name, '=', value);
    setNewSellerFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddNewSeller = async (e) => {
    e.preventDefault();
    console.log('handleAddNewSeller - Current form data:', JSON.stringify(newSellerFormData));
    console.log('Years value being sent:', newSellerFormData.years);
    console.log('Package value being sent:', newSellerFormData.package);
    
    setIsLoading(true);
    try {
      const response = await fetch('/api/vcseller', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newSellerFormData)
      });

      const responseText = await response.text();
      
      // Try to parse as JSON, if it fails, show the raw response
      let errorData;
      try {
        errorData = JSON.parse(responseText);
      } catch {
        errorData = { error: `Server error: ${responseText.substring(0, 200)}` };
      }

      if (!response.ok) {
        throw new Error(errorData.error || errorData.details || `HTTP ${response.status}: Failed to create seller`);
      }

      let newSeller;
      try {
        newSeller = JSON.parse(responseText);
      } catch {
        throw new Error('Invalid response from server');
      }
      
      setSellers([...sellers, newSeller]);
      setMessage('Seller added successfully');
      setShowAddForm(false);
      setNewSellerFormData({
        firstName: '',
        lastName: '',
        companyName: '',
        phoneNumber: '',
        emailID: '',
        passwrd: '',
        website: '',
        city: '',
        state: '',
        pan: '',
        gst: '',
        startDate: '',
        endDate: '',
        years: 1,
        package: '',
        packageDetail: ''
      });
    } catch (error) {
      console.error('Error adding seller:', error);
      setMessage('Failed to add seller: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = (seller) => {
    setEditingSeller(seller);
    setEditFormData({
      firstName: seller.firstName,
      lastName: seller.lastName,
      companyName: seller.companyName,
      phoneNumber: seller.phoneNumber,
      emailID: seller.emailID,
      website: seller.website || '',
      city: seller.city,
      state: seller.state,
      pan: seller.pan,
      gst: seller.gst,
      startDate: seller.startDate,
      endDate: seller.endDate,
      years: seller.years || 1,
      package: seller.package || '',
      packageDetail: seller.packageDetail || ''
    });
    setShowAddForm(true);
  };

  const handleEditSellerChange = (e) => {
    const { name, value } = e.target;
    console.log('Parent handleEditSellerChange:', name, '=', value);
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateSeller = async (e) => {
    e.preventDefault();
    if (!editingSeller) return;
    console.log('handleUpdateSeller - Current edit data:', JSON.stringify(editFormData));
    console.log('Years value being updated:', editFormData.years);
    console.log('Package value being updated:', editFormData.package);

    setIsLoading(true);
    try {
      const response = await fetch(`/api/vcseller/${editingSeller.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(editFormData)
      });

      const responseText = await response.text();
      
      let errorData;
      try {
        errorData = JSON.parse(responseText);
      } catch {
        errorData = { error: `Server error: ${responseText.substring(0, 200)}` };
      }

      if (!response.ok) {
        throw new Error(errorData.error || errorData.details || `HTTP ${response.status}: Failed to update seller`);
      }

      let updatedSeller;
      try {
        updatedSeller = JSON.parse(responseText);
      } catch {
        throw new Error('Invalid response from server');
      }

      setSellers(sellers.map(s => s.id === editingSeller.id ? updatedSeller : s));
      setMessage('Seller updated successfully');
      setShowAddForm(false);
      setEditingSeller(null);
    } catch (error) {
      console.error('Error updating seller:', error);
      setMessage('Failed to update seller: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelForm = () => {
    setShowAddForm(false);
    setEditingSeller(null);
    fetchSellers();
  };

  const handleSellerDeleted = () => {
    fetchSellers();
    setSelectedSeller(null);
    setMessage('Seller deleted successfully');
  };

  if (loading) return <p>Loading sellers...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      {/* <Header title="Registered Sellers" icon={FiUsers} /> */}
      {/* <SearchBar
        placeholder="Search Registered Sellers..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      /> */}

<div className="filters-header" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
        <Header
          title="Registered Sellers"
          icon={FiUsers}
          onAddAction={() => setShowAddForm(true)}
        />
        <SearchBar
          placeholder="Search Registered Sellers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="custom-search-bar"
          showIcon={true}
          style={{ flexGrow: 1, minWidth: '200px' }}
        />
        <Button onClick={handleToggleAddForm} className="btn add-new-seller-button" style={{ flexShrink: 0 }}>
          {showAddForm ? 'Close Form' : 'Add Seller'}
        </Button>
      </div>

      {message && (
        <div style={{ 
          padding: '10px', 
          marginBottom: '10px', 
          backgroundColor: message.includes('Failed') ? '#ffebee' : '#e8f5e9',
          color: message.includes('Failed') ? '#c62828' : '#2e7d32',
          borderRadius: '4px'
        }}>
          {message}
          <button 
            onClick={() => setMessage('')}
            style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}
          >
            ×
          </button>
        </div>
      )}

      <AddSellerForm
        showAddForm={showAddForm}
        newSellerFormData={newSellerFormData}
        handleNewSellerChange={handleNewSellerChange}
        handleAddNewSeller={handleAddNewSeller}
        isLoading={isLoading}
        handleToggleAddForm={handleToggleAddForm}
        editingSeller={editingSeller}
        handleEditSellerChange={handleEditSellerChange}
        handleUpdateSeller={handleUpdateSeller}
        onCancel={handleCancelForm}
        onEditComplete={fetchSellers}
      />

      <div className="page-container">
        {/* <RegisteredTable sellers={filteredSellers} onRowClick={handleRowClick} /> */}
      <RegisteredTable 
          sellers={filteredSellers} 
          onRowClick={handleRowClick}
          onSellerDeleted={handleSellerDeleted}
          onEditClick={handleEditClick}
        />
      </div>
      {selectedSeller && (
        <SelectedPopup itemType="registeredSeller" seller={selectedSeller} onClose={closePopup} />
      )}
    </>
  );
};

export default RegisteredSellersPage;
